import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  DialogActions,
} from "@mui/material";
import { PrimaryButton } from "../../../shared/ui/PrimaryButton";
import { SecondaryButton } from "../../../shared/ui/SecondaryButton";

function TitleForm({ onClose, setTitle, title }) {
  const handleSubmit = () => {
    onClose();
  };

  return (
    <Box>
      <Typography sx={{ mb: 1 }}>Назва</Typography>
      <TextField
        fullWidth
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        sx={{ mb: 3 }}
        variant="outlined"
        size="small"
      />

      <DialogActions sx={{ p: 0, justifyContent: "start" }}>
        <PrimaryButton onClick={handleSubmit}>Зберегти</PrimaryButton>
        <SecondaryButton onClick={onClose}>Закрити</SecondaryButton>
      </DialogActions>
    </Box>
  );
}

export default TitleForm;
